import { Injectable } from "@angular/core";
import { createEffect, Actions, ofType, Effect } from "@ngrx/effects";
import { NotificationService } from "@cradua/core";
import {
  map,
  catchError,
  concatMap,
  exhaustMap,
  switchMap,
  mergeMap,
  takeUntil,
   withLatestFrom, filter, tap
} from "rxjs/operators";
import { of, Observable } from "rxjs";
import * as GenericActions from "./pipeline-generic.actions";
import { PipelineGenericService } from "../../service/pipeline-generic.service";
import { Action, Store } from "@ngrx/store";
import { PipelineGenericStoreReducer, PipelineGenericStoreSelectors } from './index';

@Injectable()
export class PipelineGenericEffects {
  mainActionType: string;

  loadPipelineSection$ = createEffect(() =>
    this.loadAllData(GenericActions, "PipelineSection")
  );

  loadPipelineSectionById$ = createEffect(() =>
  this.loadAllDataById(GenericActions, "PipelineSection")
);

  clearPipelineSection$ = createEffect(() =>
    this.loadClearState(GenericActions, "PipelineSection")
  );

  addPipelineSection$ = createEffect(() => 
    this.add(GenericActions, "PipelineSection")
  );

  updatePipelineSection$ = createEffect(() =>
    this.update(GenericActions, "PipelineSection")
  );

  deletePipelineSection$ = createEffect(() =>
    this.remove(GenericActions, "PipelineSection")
  );

  
  loadAccountableFunctionLink$ = createEffect(() =>
    this.loadAllData(GenericActions, "AccountableFunctionLink2")
  );

  loadAccountableFunctionLinkById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "AccountableFunctionLink2")
  );

  addAccountableFunctionLink$ = createEffect(() => 
  this.add(GenericActions, "AccountableFunctionLink2")
  );

  updateAccountableFunctionLink$ = createEffect(() =>
    this.update(GenericActions, "AccountableFunctionLink2")
  );

  deleteAccountableFunctionLink$ = createEffect(() =>
    this.remove(GenericActions, "AccountableFunctionLink2")
  );


  loadPipelineAssetLink2$ = createEffect(() =>
    this.loadAllData(GenericActions, "PipelineAssetLink2")
  );

  loadPipelineAssetLink2ById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "PipelineAssetLink2")
  );

  addPipelineAssetLink2$ = createEffect(() => 
  this.add(GenericActions, "PipelineAssetLink2")
  );

  updatePipelineAssetLink2$ = createEffect(() =>
    this.update(GenericActions, "PipelineAssetLink2")
  );

  deletePipelineAssetLink2$ = createEffect(() =>
    this.remove(GenericActions, "PipelineAssetLink2")
  );


  loadLandTitle$ = createEffect(() =>
    this.loadAllData(GenericActions, "LandTitle")
  );

  loadLandTitleWithoutId$ = createEffect(() =>
    this.loadAllDataWithoutId(GenericActions, "LandTitle")
  );

  clearLandTitle$ = createEffect(() =>
    this.loadClearState(GenericActions, "LandTitle")
  );

  loadLandTitleById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "LandTitle")
  );

  addLandTitle$ = createEffect(() => 
    this.add(GenericActions, "LandTitle")
  );

  updateLandTitle$ = createEffect(() =>
    this.update(GenericActions, "LandTitle")
  );

  deleteLandTitle$ = createEffect(() =>
    this.remove(GenericActions, "LandTitle")
  );
  
  loadOpllPtsHistory$ = createEffect(() =>
    this.loadAllData(GenericActions, "OpllPtsHistory")
  );

  loadOpllPtsHistoryWithoutId$ = createEffect(() =>
    this.loadAllDataWithoutId(GenericActions, "OpllPtsHistory")
  );

  clearOpllPtsHistory$ = createEffect(() =>
    this.loadClearState(GenericActions, "OpllPtsHistory")
  );

  loadOpllPtsHistoryById$ = createEffect(() =>
    this.loadAllDataById(GenericActions, "OpllPtsHistory")
  );

  addOpllPtsHistory$ = createEffect(() => 
    this.add(GenericActions, "OpllPtsHistory")
  );

  updateOpllPtsHistory$ = createEffect(() =>
    this.update(GenericActions, "OpllPtsHistory")
  );

  deleteOpllPtsHistory$ = createEffect(() =>
    this.remove(GenericActions, "OpllPtsHistory")
  );


  public SetActionType(type: string) {
    this.mainActionType = type;
  }

  protected loadClearState(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.loadGenericClearState(type)),
      mergeMap((action) => of(actions.loadGenericClearStateSuccess(type)({ returnedData: [] }))));
    return fn;
  }

  protected loadAllData(actions, type) {

    const fn: Observable<Action> = this.actions$.pipe(
        ofType(actions.loadGeneric(type)),
        concatMap((action) =>
          of(action).pipe(
            withLatestFrom(this.store.select(PipelineGenericStoreSelectors.getAllGeneric(action.modelType))),
          ),
        ),
        // tap(([action, data]) => console.log('data from effect ', action, data)),

        switchMap(([action, entities]) => {
          if(entities.length && entities[0].AutoSerialId === action.id && action.id !== '') {
           return of(actions.loadGenericSuccess(type)({ returnedData: entities }));
          }
          return  this.pipelineGenericService.getAll(type, action.id).pipe(
            map((data) => {
              return actions.loadGenericSuccess(type)({ returnedData: data });
            }),
            catchError((error) => of(actions.loaGenericFailure(type)({ error }))),
          )
        }),
      )
      return fn;
    }


    protected loadAllDataWithoutId(actions, type) {

      const fn: Observable<Action> = this.actions$.pipe(
          ofType(actions.loadGenericWithoutId(type)),
          concatMap((action) =>
            of(action).pipe(
              withLatestFrom(this.store.select(PipelineGenericStoreSelectors.getAllGeneric(action.modelType))),
            ),
          ),
          // tap(([action, data]) => console.log('data from effect ', action, data)),

          switchMap(([action, entities]) => {
            if(entities.length && entities[0].AutoSerialId === action.id && action.id !== '') {
             return of(actions.loadGenericWithoutIdSuccess(type)({ returnedData: entities }));
            }
            return  this.pipelineGenericService.getAllWithoutId(type).pipe(
              map((data) => {
                return actions.loadGenericWithoutIdSuccess(type)({ returnedData: data });
              }),
              catchError((error) => of(actions.loadGenericWithoutIdFailure(type)({ error }))),
            )
          }),
        )
        return fn;
      }

    protected loadAllDataById(actions, type) {

      const fn: Observable<Action> = this.actions$.pipe(
          ofType(actions.loadByIdGeneric(type)),
          concatMap((action) =>
            of(action).pipe(
              withLatestFrom(this.store.select(PipelineGenericStoreSelectors.getAllGeneric(action.modelType))),
            ),
          ),
          // tap(([action, data]) => console.log('data from effect ', action, data)),

          switchMap(([action, entities]) => {
            if(entities.length && entities[0].AutoSerialId === action.id && action.id !== '') {
             return of(actions.loadByIdGenericSuccess(type)({ returnedData: entities }));
            }
            return  this.pipelineGenericService.getAllById(type, action.id).pipe(
              map((data) => {
                return actions.loadByIdGenericSuccess(type)({ returnedData: data });
              }),
              catchError((error) => of(actions.loadByIdGenericFailure(type)({ error }))),
            )
          }),
        )
        return fn;
      }

  protected add(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.addGeneric(type)),
      concatMap(({ dataToAdd }) =>
        this.pipelineGenericService
          .createData(type, dataToAdd)
          .pipe(
            map((data) => {
              console.log('addddd ', data)
              this.notification.success("Saved Successfully");
              return actions.addGenericSuccess(type)({ returnedData: data })
            }

            ),
            catchError((error) =>
              of(
                actions.addGenericFailure(type)({ error: error.error.message }),
              )
            ),
          )
      ),
    );
    return fn;
  }
  protected update(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.updateGeneric(type)),
      concatMap(({ dataToAdd, deletedData }) =>
        this.pipelineGenericService
          .updateData(type, dataToAdd, deletedData)
          .pipe(
            map((data) => {
              this.notification.success("Updated Successfully");
              return actions.updateGenericSuccess(type)({ returnedData: data })
            }),
            catchError((error) =>
              of(
                actions.updateGenericFailure(type)(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    );
    return fn;
  }
  protected remove(actions, type) {
    const fn: Observable<Action> = this.actions$.pipe(
      ofType(actions.removeGeneric(type)),
      concatMap(({ ids }) =>
        this.pipelineGenericService
          .deleteData(type, ids)
          .pipe(
            map((data) => {
              this.notification.success("Deleted Successfully");
              return actions.removeGenericSuccess(type)({ ids })
            }),
            catchError((error) =>
              of(
                actions.updateGenericFailure(type)(
                  { error: error.error.message },
                ),
              )
            ),
          )
      ),
    );
    return fn;
  }

  constructor(
    private actions$: Actions,
    private pipelineGenericService: PipelineGenericService,
    private store: Store<PipelineGenericStoreReducer.GenericPartialState>,
    private notification: NotificationService,
  ) {}
}
